import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { StyledMenuItemTag } from '@bingads-webui-react/menu-item-tag';
import { NewFeatureTagStyles } from './ui-next-jss/new-feature-tag';

const UnstyledMenuItemTagContainer = ({ tagContent, classes, i18n }) => (
  <div className={classes.menuItemTagContainer}>
    <StyledMenuItemTag i18n={i18n} tagContent={tagContent} />
  </div>
);

UnstyledMenuItemTagContainer.propTypes = {
  classes: PropTypes.shape({
    menuItemTagContainer: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }),
  tagContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.shape({})]).isRequired,
};

UnstyledMenuItemTagContainer.defaultProps = {
  i18n: null,
};

const MenuItemTagContainer = injectSheet(NewFeatureTagStyles)(UnstyledMenuItemTagContainer);

export const NewFeatureTag = ({ i18n, expDate }) => (<MenuItemTagContainer
  i18n={i18n}
  tagContent={expDate ? {
        text: 'New_Feature_Label_NewUI',
        expDate,
      } : 'New_Feature_Label_NewUI'}
/>);

NewFeatureTag.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  expDate: PropTypes.shape({}),
};

NewFeatureTag.defaultProps = {
  expDate: null,
};
